import { httpGet } from '@/tool/request/index';

//获取枚举字段
export async function getEnumeratedFields(configCode: any) {
  return await httpGet<any>('/xcx/config/getConfigList')({
    params: {
      configCode,
    },
  });
}

// 根据药品名模糊查询药品
export async function medicationMedicines(medicineName: any) {
  return await httpGet<any>('/medication/medicines')({
    params: {
      medicineName,
    },
  });
}
